module.exports = __webpack_public_path__ + "img/undraw_Browser_stats_re_j7wy.0ac402e0.svg";